import objectsContainsInfo from "./group-10-copy-3.svg";
import objectsIntersection from "./group-10-copy-4.svg";
import result from "./bitmap-copy-5.svg";
import initialObject from "./bitmap-copy-4.svg";
import arrows from "./arrow-big.svg";

export const images = {
  initialObject,
  objectsContainsInfo,
  objectsIntersection,
  result,
  arrows,
};
